import { metricNames } from '@linearb/linjs-common';
import { boolPropsToClassNames } from 'common/utils/style.utils';
import Dropdown from 'components/base/Dropdown';
import React from 'react';
import { AGGREGATION_OPTIONS } from './AggregationSelector';
import {
  StyledDescription,
  StyledInputWrapper,
  StyledSelectorTitle
} from './ReportedMetricsModal.style';

export const DistinctCountSelector = ({
  modalState,
  setModalState,
  selectedMetric
}) => {
  const isDisabled =
    modalState.aggregation !== AGGREGATION_OPTIONS.DISTINCT_COUNT.value ||
    modalState.reportedMetric === metricNames.REPORTED_CUSTOM;
  return (
    <StyledInputWrapper>
      <StyledSelectorTitle
        className={boolPropsToClassNames({ disabled: isDisabled })}
      >
        DISTINCT COUNT
      </StyledSelectorTitle>
      <StyledDescription>
        Select from the following values. The chart will display the count of
        unique instances
      </StyledDescription>

      <Dropdown
        selectedValue={modalState.distinctCount}
        onChange={distinctCount => {
          setModalState({ ...modalState, distinctCount });
        }}
        disabled={isDisabled}
        options={(selectedMetric?.meta?.available_keys || []).map(value => ({
          value,
          displayValue: value,
          searchableValue: value
        }))}
      />
    </StyledInputWrapper>
  );
};
